export default __webpack_public_path__ + "2a61e25b21d15a75c5d6bf5b6fdefb43.svg";